import { ScreenerTransactionsParams } from "@api/token-screener/screener-transactions.ts";
import { createContext, useContext } from "react";

export const getDefaultFilters = (): ScreenerTransactionsParams["filters"] => {
  return {};
};

export const MyOrdersFilterContext = createContext<{
  filters: ScreenerTransactionsParams["filters"];
  onFiltersUpdate: (filters: ScreenerTransactionsParams["filters"]) => void;
}>({ filters: getDefaultFilters(), onFiltersUpdate: () => {} });

export const useMyOrdersFilterProvider = () => {
  const context = useContext(MyOrdersFilterContext);
  if (!context) {
    throw new Error(
      "useMyOrdersFilter must be used within a MyOrdersFilterProvider",
    );
  }
  return context;
};
